import { createContext } from "react"

const WidgetResourcesInPlaceContext = createContext();

export default WidgetResourcesInPlaceContext;